import { useState } from "react";
import { loadPurchaseReceivedReportItemTable } from "../services/purchaseIndentService";

const usePurchaseReceivedTableDet = () => {
    const [receivesDetail, setReceivesDetail] = useState([]);


    const loadPurchaseReceivesByID = async (PurchaseID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_purchase_received: PurchaseID
        };

        try {
            const data = await loadPurchaseReceivedReportItemTable(para);
            if (data && data.length > 0) {
                setReceivesDetail(data); // Assumes backend returns `material_code`

            }
        } catch (error) {
            console.error("Failed to generate material code:", error);
        }
    };

    const loadReceivesDet = async (ReceivesID) => {
       await loadPurchaseReceivesByID(ReceivesID);
    }


    return {
        receivesDetail,
        setReceivesDetail,
        loadReceivesDet
    };
};

export default usePurchaseReceivedTableDet;